import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

import {
  sendAnalyticsEvent,
  EventMetricsKeys,
  EventMetricsTypes,
} from '@/common/ufo/analytics-events';

import useNavigationController from './navigation-controller';

const useLegacySearchRedirectController = () => {
  const location = useLocation();
  const { onNavigation } = useNavigationController();

  // Trigger this only once when the hook is called on the homepage, as this is
  // to handle the case where the view is coming from a bookmarked legacy page.
  useEffect(() => {
    const urlObject = qs.parse(location.search);
    if (
      location.pathname === '/' &&
      ('teamPublicIds' in urlObject ||
        'productPublicIds' in urlObject ||
        'capabilityPublicIds' in urlObject)
    ) {
      // Only redirect if the capability is not specified also team and product
      // are not both specified at the same time.
      if (
        !('capabilityPublicIds' in urlObject) &&
        !('teamPublicIds' in urlObject && 'productPublicIds' in urlObject)
      ) {
        // Techops url does not show drafts by default, but we want this option in case
        // any team has bookmarked / configured the url with the showDrafts query param.
        const showDrafts = urlObject.showDrafts === 'true';

        // Only redirect if the team has single publicId specified
        if ('teamPublicIds' in urlObject && !urlObject.teamPublicIds?.includes(',')) {
          if (urlObject.source === 'slo-quality-recommendations') {
            onNavigation({
              search: `?hasQualityIssuesOnly=true${showDrafts ? '&showDrafts=true' : ''}`,
              pathname: `/team/${urlObject.teamPublicIds}/dashboard`,
            });
            sendAnalyticsEvent(
              EventMetricsTypes.Track,
              EventMetricsKeys.PageRedirectedSLOQualityRecommendations
            );
          } else {
            onNavigation({
              search: showDrafts ? '?showDrafts=true' : '',
              pathname: `/team/${urlObject.teamPublicIds}/dashboard`,
            });
            sendAnalyticsEvent(EventMetricsTypes.Track, EventMetricsKeys.PageRedirectedTeam);
          }
          return;
        }

        // Only redirect if the product has single publicId specified
        if ('productPublicIds' in urlObject && !urlObject.productPublicIds?.includes(',')) {
          onNavigation({
            search: showDrafts ? '?showDrafts=true' : '',
            pathname: `/product/${urlObject.productPublicIds}/dashboard`,
          });
          sendAnalyticsEvent(EventMetricsTypes.Track, EventMetricsKeys.PageRedirectedProduct);
          return;
        }
      }

      onNavigation({
        search: location.search,
        pathname: '/catalog',
      });
      sendAnalyticsEvent(EventMetricsTypes.Track, EventMetricsKeys.PageRedirectedLegacyCatalog);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {};
};

export default useLegacySearchRedirectController;
